enum ProviderPushbackMainTypes {
  PRE_CARE = "Pre_Care"
}

export default ProviderPushbackMainTypes;
